import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "inspect-cover",
  "use": "inspect-cover-usage",
  "viewBox": "0 0 63.34 77",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63.34 77\" id=\"inspect-cover\"><defs><style>#inspect-cover .cls-1{fill:#fff;opacity:.2}</style></defs><title>资源 23</title><g id=\"inspect-cover_图层_2\" data-name=\"图层 2\"><g id=\"inspect-cover_图层_1-2\" data-name=\"图层 1\"><path d=\"M63.26 11.16h-3.13A44.62 44.62 0 0 1 45.8 8a66.89 66.89 0 0 1-12.27-6.61L31.63 0l-1.86 1.39A61.64 61.64 0 0 1 17.5 8a44.81 44.81 0 0 1-14.33 3.12L0 11.16v32.39C0 59.82 20.59 77 31.67 77s31.67-17.18 31.67-33.45zM45.13 40.8a4.7 4.7 0 0 1-4.25 2.7h-4.27v6.32a4.65 4.65 0 0 1-.9 2.75 4.7 4.7 0 0 1-8.94-2v-7h-4.7a4.7 4.7 0 0 1-3.38-8 4.68 4.68 0 0 1 3.89-2.08h4.18V27a4.68 4.68 0 0 1 1.3-3.24 4.68 4.68 0 0 1 8.55 2.63v7h4.69a4.67 4.67 0 0 1 3.83 7.36z\" /><path class=\"cls-1\" d=\"M27.39 2.86c-.64 0-13.17 9.15-27.11 8.28v32c0 11.22 9.17 25.76 26.39 33 20.04-9.88 38-47.62.72-73.28z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/inspect-cover.svg
// module id = oTFP
// module chunks = 6